<template>
    <div id="sneak">

    </div>
</template>

<script>
    export default {
        name: "Sneak",
        methods : {
            doSneak(){
                this.axios.post('/api/login/sneak',{
                    encode : this.$route.params.encode
                }).then(r => {
                    let data = r.data;
                    if(data.code == 0){
                        this.$message.error(data.msg);
                    }else{
                        this.$message.success(data.msg);
                        //存储用户信息
                        this.$store.dispatch('setUserInfo',data.data);
                        this.$router.push('/');
                    }
                })
            }
        },created(){
            this.doSneak();
        }
    }
</script>

<style lang="less">
#sneak{

}
</style>
